<template>
  <v-container>
    <v-row>
      <v-col :cols="isMobile ? 12 : 4">
        <v-text-field label="Full Names" v-model="name"></v-text-field>
      </v-col>

      <v-col :cols="isMobile ? 12 : 4">
        <v-text-field
          :label="'ID Number[Optional]'"
          v-model="clientReference"
        ></v-text-field>
      </v-col>

      <v-col :cols="isMobile ? 12 : 4">
        <v-text-field
          label="Phone Number [Optional]"
          v-model="phone"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="isMobile ? 12 : 4">
        <v-text-field
          label="Description [Optional]"
          v-model="institution"
        ></v-text-field>
      </v-col>
      <v-col :cols="isMobile ? 6 : 4">
        <v-text-field
          label="Person In Charge [Optional]"
          v-model="position"
        ></v-text-field>
      </v-col>

      <v-col :cols="isMobile ? 6 : 4">
        <v-text-field label="Email [Optional]" v-model="email"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="isMobile ? 12 : 4">
        <v-text-field
          label="Physical Address [Optional]"
          v-model="address"
        ></v-text-field>
      </v-col>
      <v-col :cols="isMobile ? 6 : 4">
        <v-text-field label="City [Optional]" v-model="city"></v-text-field>
      </v-col>

      <v-col :cols="isMobile ? 6 : 4">
        <v-text-field
          label="Postal Code [Optional]"
          v-model="postalCode"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4"> </v-col>
      <v-col cols="4">
        <v-btn
          color="teal"
          dark
          rounded
          large
          class="mx-auto"
          @click="saveClient()"
        >
          Submit
        </v-btn>
      </v-col>
      <v-col cols="4"> </v-col>
    </v-row>
  </v-container>
</template>

<script>
import clientsJs from "@/plugins/clients";

export default {
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data() {
    return {
      name: null,
      clientReference: null,
      phone: null,
      institution: "General Company",
      position: "Staff",
      email: "abc@gmail.com",
      address: "123 Ulundi Street",
      city: "Ulundi",
      postalCode: "3838",
    };
  },
  methods: {
    async saveClient() {
      this.$store.commit("setLoader", true);
      const client = await clientsJs.createClient(
        this.name,
        this.clientReference,
        this.phone,
        this.institution,
        this.position,
        this.email,
        this.address,
        this.city,
        this.postalCode
      );
      this.$emit("client-created", client);
      this.$store.commit("setLoader", false);
      this.$toast.success("Client Created Successfully!", { duration: 3000 });
    },
  },
};
</script>

<style></style>
